export const article = [
  {
    articleId: 32,
    url: "se-te-cobro-despues-de-cancelar-mega-go",
    category: {
      slug:"facturacion",
      name: "Facturación"
    },
    title: "Se te cobró después de cancelar Mega GO",
    content: 
      <>
        <div className="row">
          <p>Si cancelaste tu cuenta, pero aun así ves un cargo, es posible que tú o alguien que usaba tu cuenta la haya reiniciado por error. Si no puedes completar los siguientes pasos, comunícate con nosotros. </p>
        </div>
        <div className="">
          <p>Inicia sesión en <a href='https://megago.cl/' target="_blank">megago.cl</a> y haz lo siguiente: </p>
          <ul className="decimal">
            <li>Cancela tu cuenta.
              <ul className="disc">
                <li>Tienes que ingresar a <a href='https://megago.cl/cuenta/plan' target="_blank">megago.cl/cuenta/plan</a>, donde te figurará el botón "Cancelar mi plan". Presiónalo para que te lleve al recuadro de confirmación, donde te aparecerá la fecha de vigencia que tendrá tu cuenta full.</li>
                <li>Confirma tu cancelación con el botón enmarcado de color rojo "Cancelar suscripción" donde posteriormente te aparecerá que se realizó la cancelación de tu suscripción exitosamente.</li>
              </ul>
            </li>
            <li>Cambia tu contraseña para evitar que alguien pueda iniciar en tu cuenta.
              <ul className="disc">
                <li>Pincha <a href='https://sso.mega.cl/auth/realms/megamedia/login-actions/reset-credentials?client_id=megago-web' target="_blank">aquí</a> y cambia tu contraseña.</li>
              </ul>
            </li>
          </ul>
        </div>
      </>
  }
];